/**
 * Loading Animation Assets
 *
 * Lottie animation paths for loading states.
 */

/**
 * Base path for animation assets
 */
const ANIMATIONS_BASE = '/assets/animations';

/**
 * Animation asset definition
 */
export interface AnimationAsset {
  /** Path to the Lottie JSON file */
  path: string;
  /** Animation name */
  name: string;
  /** Default loop setting */
  loop: boolean;
  /** Default autoplay setting */
  autoplay: boolean;
}

/**
 * Loading animation variants
 */
export const LOADING_ANIMATIONS = {
  spinner: {
    path: `${ANIMATIONS_BASE}/loading-spinner.json`,
    name: 'Spinner',
    loop: true,
    autoplay: true,
  },
  dots: {
    path: `${ANIMATIONS_BASE}/loading-dots.json`,
    name: 'Loading Dots',
    loop: true,
    autoplay: true,
  },
  pulse: {
    path: `${ANIMATIONS_BASE}/loading-pulse.json`,
    name: 'Pulse',
    loop: true,
    autoplay: true,
  },
  tonnie: {
    path: `${ANIMATIONS_BASE}/loading-tonnie.json`,
    name: 'Tonnie Loading',
    loop: true,
    autoplay: true,
  },
} as const;

/**
 * Loading animation types
 */
export type LoadingAnimationType = keyof typeof LOADING_ANIMATIONS;

/**
 * Get loading animation
 */
export function getLoadingAnimation(type: LoadingAnimationType = 'spinner'): AnimationAsset {
  return LOADING_ANIMATIONS[type];
}
